
export const url = 'http://gl.ncha.gov.cn' // 测试
export const url2 = 'http://gl.ncha.gov.cn' // 测试

// 配置生产环境 客户部署地址：http://gl.ncha.gov.cn 测试部署地址：http://gl.ncha.gov.cn
export const productionBaseUrl = 'http://gl.ncha.gov.cn'

/**工作台跳转地址*/
//测试部署地址：
const testDeployUrl = `http://gl.ncha.gov.cn:8088/#/login`
// 客户部署地址：
const clientDeployUrl = `http://gl.ncha.gov.cn:8088/#/login`
// 本地开发环境地址
const devBaseUrl = 'http://localhost:8080/#/login?type=3'
export const jumpAddress = process.env.NODE_ENV === 'development' ? testDeployUrl : clientDeployUrl

/**门户在线办理跳转地址*/
//测试部署地址：
const testHandleUrl = `http://gl.ncha.gov.cn:8088/#/home`
// 客户部署地址：
const clientHandleUrl = `http://gl.ncha.gov.cn:8088/#/home`
export const jumpHandle = process.env.NODE_ENV === 'development' ? testHandleUrl : clientHandleUrl

